import { action, computed } from "@ember/object";
import { service } from "@ember/service";
import { attributeBindings, classNames } from "@ember-decorators/component";
import { uniqueItemsFromArray } from "discourse/lib/array-tools";
import { bind } from "discourse/lib/decorators";
import { makeArray } from "discourse/lib/helpers";
import MultiSelectComponent from "select-kit/components/multi-select";
import { pluginApiIdentifiers, selectKitOptions } from "select-kit/components/select-kit";
import SelectKitRow from "./select-kit/select-kit-row";
import TagChooserRow from "./tag-chooser-row";
const TagChooser = dt7948.c(class TagChooser extends MultiSelectComponent {
  static {
    dt7948.g(this.prototype, "tagUtils", [service]);
  }
  #tagUtils = (dt7948.i(this, "tagUtils"), void 0);
  blockedTags = null;
  excludeSynonyms = false;
  excludeHasSynonyms = false;
  init() {
    super.init(...arguments);
    this.setProperties({
      blockedTags: this.blockedTags || [],
      termMatchesForbidden: false,
      termMatchErrorMessage: null
    });
  }
  modifyComponentForRow(collection, item) {
    if (this.getValue(item) === this.selectKit.filter && !item.count) {
      return SelectKitRow;
    }
    return TagChooserRow;
  }
  get canCreateTag() {
    return this.allowCreate && this.site.can_create_tag;
  }
  static {
    dt7948.n(this.prototype, "canCreateTag", [computed("site.can_create_tag", "allowCreate")]);
  }
  get maximumTagCount() {
    if (!this.unlimitedTagCount) {
      return parseInt(this.options.limit || this.options.maximum || this.siteSettings.max_tags_per_topic, 10);
    }
    return null;
  }
  static {
    dt7948.n(this.prototype, "maximumTagCount", [computed("siteSettings.max_tags_per_topic", "unlimitedTagCount")]);
  }
  get value() {
    return uniqueItemsFromArray(makeArray(this.tags));
  }
  static {
    dt7948.n(this.prototype, "value", [computed("tags.[]")]);
  }
  get content() {
    return uniqueItemsFromArray(makeArray(this.tags)).map(t => this.defaultItem(t, t));
  }
  static {
    dt7948.n(this.prototype, "content", [computed("tags.[]")]);
  }
  _onChange(value, items) {
    if (this.onChange) {
      this.onChange(value, items);
    } else {
      this.set("tags", value);
    }
  }
  static {
    dt7948.n(this.prototype, "_onChange", [action]);
  }
  validateCreate(filter, content) {
    return this.tagUtils.validateCreate(filter, content, this.selectKit.options.maximum, e => this.addError(e), this.termMatchesForbidden, value => this.getValue(value), this.value);
  }
  createContentFromInput(input) {
    return this.tagUtils.createContentFromInput(input);
  }
  search(query) {
    const selectedTags = makeArray(this.tags).filter(Boolean);
    const data = {
      q: query,
      limit: this.siteSettings.max_tag_search_results,
      categoryId: this.categoryId
    };
    if (selectedTags.length || this.blockedTags.length) {
      data.selected_tags = uniqueItemsFromArray(selectedTags.concat(this.blockedTags)).slice(0, 100);
    }
    if (!this.everyTag) {
      data.filterForInput = true;
    }
    if (this.excludeSynonyms) {
      data.excludeSynonyms = true;
    }
    if (this.excludeHasSynonyms) {
      data.excludeHasSynonyms = true;
    }
    return this.tagUtils.searchTags("/tags/filter/search", data, this._transformJson);
  }
  _transformJson(json) {
    if (this.isDestroyed || this.isDestroying) {
      return [];
    }
    let results = json.results;
    this.setProperties({
      termMatchesForbidden: json.forbidden ? true : false,
      termMatchErrorMessage: json.forbidden_message
    });
    if (this.blockedTags) {
      results = results.filter(result => {
        return !this.blockedTags.includes(result.id);
      });
    }
    if (this.siteSettings.tags_sort_alphabetically) {
      results = results.sort((a, b) => a.id > b.id);
    }
    return uniqueItemsFromArray(results, "id");
  }
  static {
    dt7948.n(this.prototype, "_transformJson", [bind]);
  }
}, [pluginApiIdentifiers("tag-chooser"), selectKitOptions({
  filterable: true,
  filterPlaceholder: "tagging.choose_for_topic",
  limit: null,
  allowAny: "canCreateTag",
  maximum: "maximumTagCount"
}), attributeBindings("categoryId"), classNames("tag-chooser")]);
export default TagChooser;